/**
 * KLine的ENE
 */
import {
  LINE_TYPE,
} from '../../viewmodel/setting.js';
import KLineState from '../kline';
import KLineFootDectorator from '../dectorator/klinefootdectorator';
import {checkMainAuth, checkMainTitleAuth} from '../dectorator/checkauthdectorator/index.js';
import Util, {mergeModelData, curryFun} from '../../util/index.js';
const model = {
  kline: {
    Type: Array,
    Deep: true, // 深拷贝, 避免与K线图操作同一个数据引起lineY异常
    Default: () => ([])
  },
  upper: {
    Type: Array,
    Default: () => ([])
  },
  lower: {
    Type: Array,
    Default: () => ([])
  },
  ene: {
    Type: Array,
    Default: () => ([])
  }
};
export default class KLineENEState extends KLineFootDectorator(KLineState) {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    super._calcRange();
    const {upper, lower, ene} = this.state.data;
    let {maxValue, minValue} = this.calcRange({data: [upper, lower, ene], targetKey: 'value', isAdditional: true});
    if (maxValue === minValue && maxValue === 0) {
      maxValue = 1;
      minValue = -1;
    } else {
      maxValue *= 1.1;
      minValue *= 0.9;
    }
    this.maxValue = maxValue;
    this.minValue = minValue;
  }
  _calcAxis() {
    super._calcAxis();
    const {upper, lower, ene} = this.state.data;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({data: upper});
    curryCalcAxis({data: lower});
    curryCalcAxis({data: ene});
  }
  _drawMain() {
    super._drawMain();
    const {upper, lower, ene} = this.state.data;
    const {
      left,
      bottom,
      width
    } = this.availArea;
    const {LINE} = LINE_TYPE;
    const {upper: UPPER, lower: LOWER, ene: ENE} = this.option.ENE;
    this._drawLine(LINE, upper, left, bottom, UPPER.lineWidth, UPPER.color);
    this._drawLine(LINE, lower, left, bottom, LOWER.lineWidth, LOWER.color);
    this._drawLine(LINE, ene, left, bottom, ENE.lineWidth, ENE.color);
  }
  _drawAxisY() {
    const {
      top,
      bottom,
      right
    } = this.availArea;
    const maxValue = this.maxValue;
    const minValue = this.minValue;
    const ctx = this.context;
    ctx.beginPath();
    const {sizeRatio, fontFamily, color} = this.option.ENE.axisY;
    ctx.font = sizeRatio * this.state.baseSize * this.dpr + 'px ' + fontFamily;
    ctx.strokeStyle = color;
    ctx.textAlign = 'right';
    ctx.textBaseline = 'top';
    ctx.fillText(maxValue.toFixed(2), right, top);
    ctx.textBaseline = 'bottom';
    ctx.fillText(minValue.toFixed(2), right, bottom);
  }
  // @checkMainTitleAuth
  _drawTitle() {
    const ctx2 = this.curContext;
    const {top} = this.availArea;
    const {current, sealObj} = this.state.data;
    const {height, baseSize} = this.state;
    const {ratioFixed} = sealObj;
    const {space} = this.option.ENE;
    const {baseLine} = this.option.FootContext.title;
    const baseLineY = top + height * baseLine;
    let {left} = this.availArea;
    [
      'upper',
      'lower',
      'ene',
    ].forEach(val => {
      const data = this.state.data[val];
      if (Util.isArray(data)) {
        const {
          sizeRatio,
          fontFamily,
          color,
        } = this.option.ENE[val];
        ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
        ctx2.fillStyle = color;
        ctx2.textAlign = 'left';
        ctx2.textBaseline = 'top';
        ctx2.beginPath();
        const item = data[current];
        if (Util.isDef(item) && Util.isValidNumber(item.value)) {
          const text = val.toUpperCase() + ': ' + item.value.toFixed(ratioFixed);
          const textWidth = ctx2.measureText(text).width;
          ctx2.fillText(text, left, baseLineY);
          left += textWidth;
        } else {
          const text = val.toUpperCase() + ': -';
          const textWidth = ctx2.measureText(text).width;
          ctx2.fillText(text, left, baseLineY);
          left += textWidth;
        }
        left += space * this.dpr;
      }
    })
  }
}